export const darkTheme = {
  bg: "black",
  text_primary: "#f5f0ec",
  text_secondary: "RGBA(255, 255, 255, 0.7)",
  card: "#171721",
  card_light: "#191924",
  button: "#854CE6",
};

export const lightTheme = {
  bg: "#f5f0ec",
  bgLight: "#f0f0f0",
  primary: "#48494a", 
  text_primary: "#222222",
  text_secondary: "#464646",
  card: "#FFFFFF",
  button: "#5c5b5b",
  white: "#FFFFFF",
  black: "#000000",
};
